@defer {
  @if (!storageService.cookeyApprove.value) {
    <div id="cookie-banner">
      <div class="cookie-container">
        <p>
          {{ "cookieMessage" | translate }}

          <a
            [routerLink]="['/', i18nService.language, 'privacy-policy']"
            target="_blank"
            translate
            >Read More</a
          >
        </p>
        <button id="accept-cookies" translate (click)="setOkey()">Okey</button>
      </div>
    </div>
  }
}
